<template>
  <div>
    <table class="basket-table cartTable table-responsive m-b-30">
      <thead>
        <tr class="CartProduct cartTableHeader">
          <th width="70%">Product</th>
          <th>Quantity</th>
          <th style="white-space: nowrap;">Price</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!basket.length">
          <td colspan="3">There are no items in the basket</td>
        </tr>
        <tr v-else v-for="(item, index) in basket" class="CartProduct">
          <td><a :href="'/product/' + item.slug" :title="'View ' + item.name"><span v-if="sku === 1"><b>{{ item.sku
          }}</b></span><span v-if="name === 1"><b>: </b> {{ item.name }}</span></a> - {{ item.desc }}</td>
          <td>
            <input :name="item.name + ' Quantity ' + index" type="number" pattern="[0-9]*" :min="item.minSaleCount" :max="500"
              v-validate="{ min_value: (item.minSaleCount ? item.minSaleCount : 1), max_value: 500, required: true }"
              data-vv-as="quantity" inputmode="numeric" :value="item.quantity" v-on:input="updateQuantity(item, index, $event)"
              :disabled="item.isAccessory" style="width:60px" />
            <a v-if="!item.isAccessory" href="#" title="Delete product" @click="delItem(index)"
              class="basket-delete no-underline"><i class="dashicons dashicons-trash"></i></a>
            <p v-show="errors.has(item.name + ' Quantity ' + index)" class="control has-icon has-icon-right qty-error"><i
                class="fa fa-warning" style="color: #E74C3C;"></i>
              <span class="help has-error"> {{ errors.first(item.name + ' Quantity ' + index) }}</span>
            </p>
          </td>
          <td style="white-space: nowrap;">£{{ itemPrice(item) | money}}</td>
        </tr>
        <tr>
          <td></td>
          <th>Delivery:</th>
          <td v-if="basketValues.shipping" colspan="2" class="y-basket-value" style="white-space: nowrap;">£ {{
            basketValues.shipping | money }}</td>
          <td v-else colspan="2" class="y-basket-value">£ {{ 0 | money }}</td>
        </tr>
        <tr>
          <td></td>
          <th>Total (net):</th>
          <td v-if="basketValues.net" colspan="2" class="y-basket-value" style="white-space: nowrap;">£ {{
            basketValues.net | money }}</td>
          <td v-else colspan="2" class="y-basket-value">£ {{ 0 | money }}</td>
        </tr>
        <tr>
          <td></td>
          <th>VAT:</th>
          <td v-if="basketValues.tax" colspan="2" class="y-basket-value" style="white-space: nowrap;">£{{ basketValues.tax
            | money }}</td>
          <td v-else colspan="2" class="y-basket-value">£ {{ 0 | money }}</td>
        </tr>
        <tr v-if="codeStatus === 'valid'">
          <td><b>Discount:</b> {{ discountPercentage }}% off products<label v-if="discountShipping === 1" style="font-weight: 400;">and delivery</label></td>
          <th>Discount:</th>
          <td colspan="2" class="y-basket-value" style="white-space: nowrap;" v-if="basketValues.discount">
            -£{{ basketValues.discount }}</td>
          <td colspan="2" class="y-basket-value" style="white-space: nowrap;" v-else>-£0</td>
        </tr>
        <tr>
          <td></td>
          <th>Total:</th>
          <td v-if="basketValues.gross" colspan="2" class="y-basket-value" style="white-space: nowrap;">£{{
            basketValues.gross | money }}</td>
          <td v-else colspan="2" class="y-basket-value">£ {{ 0 | money }}</td>
        </tr>
      </tbody>
    </table>
    <div class="yodah-flex-container" style="justify-content: space-between;">
      <div class="flex-30">
        <input id="discount" ref="discount" class="form-control input" name="discount" type="text"
          placeholder="Discount code" v-model="discountCode"/>
      </div>
      <div class="flex-20">
        <button v-on:click.prevent="discount" class="y-btn y-basket-btn flex-100">Apply</button>
      </div>
      <div class="flex-40" v-if="codeStatus">
        <span v-if="codeStatus === 'valid'" class="alert alert-success">Your discount code is <b>Valid</b>.</span>
        <span v-if="codeStatus === 'expired'" class="alert alert-info">Your discount code is <b>Expired</b>.</span>
        <span v-if="codeStatus === 'invalid'" class="alert alert-danger">Your discount code is <b>Invalid</b>.</span>
      </div>
      <div class="flex-40" v-else=""></div>

    </div>

    <div class="">
      <button :disabled="disabled" v-on:click.prevent="checkout" class="y-btn checkout-button pull-right">Checkout<span
          class="dashicons dashicons-arrow-right-alt2"></span></button>

    </div>
  </div>
</template>
<script>

//import TextInput from "./text-input.vue";
import { mapState } from 'vuex'
import axios from "axios";
import {calculateItemPrice} from "./mixins/calculateItemPrice";

export default {
  components:
  {
    'TextInput': () => import(/* webpackChunkName: "TextInput-basket-table" */ './text-input.vue')
  },
  el: '#basket-table',
  mixins: [calculateItemPrice],
  data() {
    return {
      discountCode: this.$store.state.discountCode,
      name: jQuery("#data-name").data("name"),
      sku: jQuery("#data-basket").data("basket"),
      shippingCalculation: jQuery("#data-shipping-calculation").data("shipping-calculation"),
      products: [],

    }
  },
  computed: {
    ...mapState(["basket", "basketValues", "loggedInToken", "discountPercentage", "discountApplied", "discountMsg", "discountShipping", "codeStatus"]),
    disabled() {
      return this.basket.length === 0;
    },
    isExpired() {
      const today = new Date();
      const expiration = new Date(this.expirationDate);
      // console.log('Expiration date ', expiration);
      //return false;
      return today > expiration;
    }
  },
  beforeMount() {
    //this.$store.dispatch('testing');
    // this.$store.dispatch('calculateBasketValues', "update");
    this.$store.commit('updateShippingCalculation', this.shippingCalculation);
  },
    methods: {
    discount() {
      this.$store.commit('setDiscountCode', this.discountCode);
      this.$store.dispatch('calculateBasketValues');
    },
    itemPrice(item){
        let data = {};
        data.quantity = +item.quantity;
        data.product = item;
        return this.calculateItemPrice(data) * data.quantity;
    },
    getProduct(item) {
      let form_data = new FormData;
      form_data.append('action', 'yodah_product_selector_query');
      form_data.append('product', item);

      axios.post(my_ajax_object.ajax_url, form_data).then((response) => {
        this.product = response.data.data.sales_discounts;
      }).catch((error) => {
        console.log(error);
      })
    },
    created() {

    },
    refreshPage() {
      window.location.reload();
    },
    async checkout() {
      let result = await this.$validator.validateAll();
      if (!result) {
        return false;
      }
      window.location.href = '/checkout';
    },
    delItem(item) {
      this.gaRemoveAll(item);
      this.ga4RemoveAll(item);
      //this.$store.dispatch('testing');
      this.$store.dispatch('delItemFromBasket', item)
        .then(() => {
          // todo return this.$notify({ title: 'Success', text: 'Item deleted'});
        }).catch((error) => {
          // todo return this.$notify({ type: 'error', text: 'There was a problem: ' + error});
        });
      // const basketLngt = this.basket.length;
      // if (basketLngt == 0) {
      //   this.refreshPage();
      // }
    },
    updateQuantity(item, index, event) {
      this.gaUpdateBasket(event.target.value, item);
      this.ga4UpdateBasket(event.target.value, item);
      // console.log('updated item', item);
      // console.log('updated item index', index)
      //this.$store.dispatch('item');
      this.$store.dispatch('updateBasketQuantity', { index: index, quantity: event.target.value });
    },
    gaReviewBasket() {
      const gaBasket = [];
      Object.keys(this.basket).forEach((item) => {
        let newItem = {
          'name': this.basket[item].name,
          'id': this.basket[item].sku,
          'price': this.basket[item].itemPrice,
          'quantity': parseInt(this.basket[item].quantity)
        }
        gaBasket.push(newItem);
      })
      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          'event': 'checkout',
          'ecommerce': {
            'checkout': {
              'actionField': { 'step': 1 },
              'products': gaBasket
            }
          },
        })
      }
    },
    ga4ReviewBasket() {
      const ga4Basket = [];
      Object.keys(this.basket).forEach((item) => {
        let newGA4Item = {
          'item_id' : this.basket[item].sku,
          'item_name': this.basket[item].name,
          'price': this.basket[item].itemPrice,
          'quantity': parseInt(this.basket[item].quantity)
        }
        ga4Basket.push(newGA4Item);
      })
      gtag("event", "view_cart", {
        currency: "GBP",
        value: this.basketValues.gross,
        items: ga4Basket
      });
    },

    gaUpdateBasket(newQty, product) {
      //this.$store.dispatch('testing');
      if (window.dataLayer) {
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        let diff = product.quantity - newQty;
        if (diff > 0) {
          dataLayer.push({
            'event': 'removeFromCart',
            'ecommerce': {
              'remove': {                               // 'remove' actionFieldObject measures.
                'products': [{                          //  removing a product to a shopping cart.
                  'name': product.name,
                  'id': product.sku,
                  'price': product.itemPrice,
                  'quantity': diff
                }]
              }
            }
          });
        } else {
          dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
              'currencyCode': 'GBP',
              'add': {                                // 'add' actionFieldObject measures.
                'products': [{                        //  adding a product to a shopping cart.
                  'name': product.name,
                  'id': product.sku,
                  'price': product.itemPrice,
                  'quantity': Math.abs(diff)
                }]
              }
            }
          });
        }
      }
    },

    ga4UpdateBasket(newQty, product) {
      let diff = product.quantity - newQty;
      if (diff > 0) {
        gtag("event", "remove_from_cart", {
          currency: "GBP",
          value: product.itemPrice,
          items: [
            {
              item_id: product.sku,
              item_name: product.name,
              price: product.itemPrice,
              quantity: Math.abs(diff)
            }
          ]
        });
      } else {
        gtag('event', 'add_to_cart', {
          currency: "GBP",
          value: this.itemPrice,
          items: [
            {
              item_id: product.sku,
              item_name: product.name,
              price: product.itemPrice,
              quantity: Math.abs(diff)
            }
          ]
        });
      }
    },

    gaRemoveAll(product) {
      if (window.dataLayer) {
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          'event': 'removeFromCart',
          'ecommerce': {
            'remove': {                               // 'remove' actionFieldObject measures.
              'products': [{                          //  removing a product to a shopping cart.
                'name': product.name,
                'id': product.sku,
                'price': product.itemPrice,
                'quantity': parseInt(product.quantity)
              }]
            }
          }
        });
      }
    },
    ga4RemoveAll(product) {
      gtag("event", "remove_from_cart", {
        currency: "GBP",
        value: product.itemPrice,
        items: [
          {
            item_id: product.sku,
            item_name: product.name,
            price: product.itemPrice,
            quantity: parseInt(product.quantity)
          }
        ]
      });
    }
  },
  async mounted() {
    if(this.$route.params.orderId){
      this.loadExistingBasket;
    }
    this.gaReviewBasket();
    // todo, if we loading exsiting basket, it should deff recalculate to make sure prices are up to date..so check this works
    await this.$store.dispatch('calculateBasketValues');
    this.ga4ReviewBasket();
    this.created();

  },

  watch: {


  },

};
</script>